import GenericRequest, { METHOD_POST } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class WorkSearchTask extends GenericRequest {

    _request; // WorkSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.WORKS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/work/list/work-search/WorkSearchTask.js